export const EPPO_EVENT_SOURCE = 'aws_firehose';

export const PROJECT = 'YGw';

export const ONGOING_EXPERIMENTS = {
    DownloadPageRedesign: 'web_app_download_page_redesign',
    ContactUsChat: 'cse-chatbot-toggle',
    PauseSubscription: 'pause_subscription_from_settings',
    ReturnOfferAfterCancellation: 'return-offer-after-cancellation',
    OneTrustBannerEnable: 'onetrust_banner_enabled',
};
